import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {externalMailingList_template} from "../components/templates/externalMailingList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class external_mailing_list extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected externalMailingList: externalMailingList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.externalMailingList = new externalMailingList_template("externalMailingList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("External Mailing Lists");
        return [this.externalMailingList.build()];
    }

    protected getModuleName(): string {
        return "external_mailing_list";
    }

    fillPage() {
        this.getMailingListData();
    }

    protected getMailingListData() {
        this.loadingIn(this.externalMailingList.builtTemplate.children.namedItem("list-results"));
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.externalMailingList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/external-mailingList/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.ongetMailingListDataReturn;
        this.XHRHdl.execute();
    }

    protected ongetMailingListDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let mailingLists = responseParsed.data;


                obj.viewModel.externalMailingList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.externalMailingList.setResultInfo(totalCount, totalPage, execTime)

                obj.externalMailingList.setMailingLists(mailingLists, obj.getBrandId())

            });
            obj.loadingOut(obj.externalMailingList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected mailingListsListReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.getMailingListData()
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getMailingListData();
    }

    protected filterSimpleOnChange(){

        this.viewModel.externalMailingList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.externalMailingList.builtTemplate.children.namedItem("list-results"));

        let mailReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/external-mailingList/get/';
        let mailReq_params: Array<Array<string>> = [];
        mailReq_params.push(["data", ko.toJSON(this.externalMailingList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(mailReq_url,mailReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.externalMailingList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any){

        // set mailing list
        let mailingToSet = [];
        for (let item of responseParsed.data) {
            mailingToSet.push( {
                id: item.id,
                idMailingList: item.idMailingList,
                label: item.label,
                dateCreated: item.dateCreated,
                dateUpdated: item.dateUpdated
            })
        }

        this.externalMailingList.setMailingLists(mailingToSet, this.getBrandId());

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.externalMailingList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.viewModel.externalMailingList.pagination.itemCount(responseParsed.totalCount);
    }

    protected viewMailingList(id) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/external-mailing-lists/view/' + id + '/')
    }

    protected addMailingList() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/external-mailing-lists/add/')
    }

    protected deleteMailingList(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/external-mailingList/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.externalMailingList.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Mailing list" + "<strong>" + data.label + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getMailingListData()
                })

                obj.loadingOut(obj.externalMailingList.builtTemplate.children.namedItem("list-results"));

            }
        });
        XHRHdl.execute();
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }
}


// WEBPACK FOOTER //
// ./js/modules/external_mailing_list.ts